// Side-effect module: importing it initialises Sentry.
//
// ES module imports are fully evaluated before any statement in the importing
// module's body, so calling initializeSentry() from an entrypoint body installs
// the global error handlers only after every other import has already run —
// leaving boot failures, the class most worth catching, unreported. Making this
// the FIRST import of an entrypoint fixes that: modules evaluate in source
// order, so Sentry is listening before Turbo, Lexxy, media-chrome, or the
// Inertia page glob get a chance to throw.
import { initializeSentry } from "@/lib/sentry"

initializeSentry()
